import { gql } from '@apollo/client/core'

export const INVOICES_GROUPED_BY_MONTH = gql`
  query InvoicesGroupByMonth($projectIds: [ID!], $periodFrom: ISO8601Date, $periodTo: ISO8601Date) {
    invoices(projectIds: $projectIds, periodFrom: $periodFrom, periodTo: $periodTo) {
      pageIndex
      totalCount
      nodes {
        id
        invoiceNumber
        status: customerStatus
        url
        netTotal
        grossTotal
        periodFrom
        periodTo
        period
        dueDate
        financialInfo {
          id
          invoiceDate
        }
        project {
          id
          name
        }
        rental {
          id
          rentalCode
        }
        invoiceItems {
          id
          name
          quantity
          unitPrice
          netTotal
          grossTotal
          periodFrom
          periodTo
          lineItem {
            id
            ... on ProductLineItemInterface {
              categorySegment {
                id
                name
              }
              equipmentIdentifier
              lineItemId
            }
          }

          unit {
            id
            name
          }
        }
      }
    }
    invoiceGroupBy {
      month(projectIds: $projectIds, periodFrom: $periodFrom, periodTo: $periodTo) {
        key
        count
        sum {
          financialInfosNetTotal
          financialInfosGrossTotal
        }
        __typename
      }
    }
  }
`
